import * as Yup from 'yup';
import { stringRequired } from '.';

export const connectDomainSchema = Yup.object({
    domain: stringRequired,
    seller: Yup.string().required()
    .oneOf([
        'GoDaddy',
        'Namecheap',
        'Google',
        'Squarespace',
        'Cloudflare',
        'Bluehost',
        'HostGator',
        'Wix',
        'Shopify',
        'Dynadot',
        'Name.com',
        'Ionos / 1&1',
        'DreamHost',
        'Gandi.net',
        'Network Solutions',
        'Amazon Route 53',
        'Google Workspace',
        'Porkbun',
        'Other'
    ], 'Seller is Required')
});

export const siteSettingSchema = Yup.object({
    title: stringRequired,
    description: stringRequired,
    favicon: stringRequired,
    socialImage: stringRequired
});
